import React from "react";
import { useDebounce } from "use-debounce";
import qs from "query-string";
import { usePagination } from "frontend/src/lib/pagination";
import { useClients } from "frontend/src/domain/client";
import { useHistory, useLocation } from "react-router-dom";
var useUserName = function (initial) {
    var _a = React.useState(""), userName = _a[0], setUserName = _a[1];
    var onChange = function (evt) {
        return setUserName(evt.target.value);
    };
    return { value: userName, set: setUserName, onChange: onChange };
};
var useLegalEntityTitle = function (initial) {
    var _a = React.useState(initial), title = _a[0], setTitle = _a[1];
    var onChange = function (evt) {
        return setTitle(evt.target.value);
    };
    return { value: title, set: setTitle, onChange: onChange };
};
var useTableSort = function (initial) {
    var _a = React.useState(initial), sortingBy = _a[0], setSortingBy = _a[1];
    var getDirectionAfterToggle = function (prop) {
        return sortingBy.value === prop && sortingBy.direction === "asc" ? "desc" : "asc";
    };
    var handleSort = function (prop) {
        setSortingBy({ direction: getDirectionAfterToggle(prop), value: prop });
    };
    var onSortByRegisterDate = function () { return handleSort("createdAt"); };
    var onSortByDebt = function () { return handleSort("debt"); };
    return {
        debt: {
            onClick: onSortByDebt,
            direction: sortingBy.value === "debt" ? sortingBy.direction : "asc",
            active: sortingBy.value === "debt",
        },
        registerDate: {
            onClick: onSortByRegisterDate,
            direction: sortingBy.value === "createdAt" ? sortingBy.direction : "asc",
            active: sortingBy.value === "createdAt",
        },
        active: sortingBy,
    };
};
var useRouteParams = function () {
    var _a, _b, _c, _d, _e, _f;
    var history = useHistory();
    var params = new URLSearchParams(useLocation().search);
    var page = Number((_a = params.get("page")) !== null && _a !== void 0 ? _a : 0);
    var rowsPerPage = Number((_b = params.get("rowsPerPage")) !== null && _b !== void 0 ? _b : 50);
    var russianLegalEntityTitle = (_c = params.get("russianLegalEntityTitle")) !== null && _c !== void 0 ? _c : "";
    var userName = (_d = params.get("userName")) !== null && _d !== void 0 ? _d : "";
    var sortByParam = (_e = params.get("sortBy")) !== null && _e !== void 0 ? _e : "debt";
    var sortBy = sortByParam === "debt" || sortByParam === "createdAt"
        ? sortByParam
        : "debt";
    var sortByDirectionParam = (_f = params.get("sortByDirection")) !== null && _f !== void 0 ? _f : "desc";
    var sortByDirection = sortByDirectionParam === "asc" || sortByDirectionParam === "desc"
        ? sortByDirectionParam
        : "desc";
    var sync = function (_a) {
        var page = _a.page, rowsPerPage = _a.rowsPerPage, russianLegalEntityTitle = _a.russianLegalEntityTitle, userName = _a.userName, sortBy = _a.sortBy, sortByDirection = _a.sortByDirection;
        return history.replace({
            search: qs.stringify({
                page: page,
                rowsPerPage: rowsPerPage,
                russianLegalEntityTitle: russianLegalEntityTitle,
                userName: userName,
                sortBy: sortBy,
                sortByDirection: sortByDirection,
            }, { skipEmptyString: true }),
        });
    };
    return {
        page: page,
        rowsPerPage: rowsPerPage,
        russianLegalEntityTitle: russianLegalEntityTitle,
        userName: userName,
        sortBy: sortBy,
        sortByDirection: sortByDirection,
        sync: sync,
    };
};
export var usePageModel = function () {
    var params = useRouteParams();
    var title = useLegalEntityTitle(params.russianLegalEntityTitle);
    var username = useUserName(params.userName);
    var russianLegalEntityTitle = useDebounce(title.value, 1000)[0];
    var userNameDebounced = useDebounce(username.value, 1000)[0];
    var sortBy = useTableSort({
        value: params.sortBy,
        direction: params.sortByDirection,
    });
    var pagination = usePagination({
        page: params.page,
        pageResetDeps: [russianLegalEntityTitle, userNameDebounced],
        rowsPerPage: params.rowsPerPage,
    });
    React.useEffect(function () {
        params.sync({
            sortBy: sortBy.active.value,
            sortByDirection: sortBy.active.direction,
            page: pagination.page,
            rowsPerPage: pagination.rowsPerPage,
            userName: userNameDebounced,
            russianLegalEntityTitle: russianLegalEntityTitle,
        });
    }, [
        sortBy.active.value,
        sortBy.active.direction,
        pagination.page,
        pagination.rowsPerPage,
        russianLegalEntityTitle,
        userNameDebounced,
    ]);
    var data = useClients({
        russianLegalEntityTitle: russianLegalEntityTitle,
        username: userNameDebounced,
        skip: pagination.skip,
        take: pagination.rowsPerPage,
        orderBy: sortBy.active.value,
        orderByDirection: sortBy.active.direction,
    }).data;
    return {
        clients: data,
        title: title,
        username: username,
        pagination: pagination,
        sortBy: sortBy,
    };
};
